import styled from "styled-components";

export default styled.div`
    margin: 20px 10px;
    border: 1px solid ${(props) => props.theme.votingCellBorder};
    border-radius: 8px;
    background-color: ${(props) => props.theme.votingCellBackground};

    .comments-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 15px 20px;
        border-bottom: 1px solid ${(props) => props.theme.votingCellBorder};

        h4 {
            margin: 0;
            color: ${(props) => props.theme.textPrimary};
            font-size: 16px;
            font-weight: 600;
        }
    }

    .no-comments {
        padding: 20px;
        text-align: center;
        color: ${(props) => props.theme.textSecondary};
        font-style: italic;
    }

    .add-comment-form {
        padding: 20px;
        border-bottom: 1px solid ${(props) => props.theme.votingCellBorder};
    }

    .edit-comment-form {
        padding: 0;
        border-bottom: none;
    }

    .add-comment-form,
    .edit-comment-form {
        textarea {
            width: 100%;
            min-height: 100px;
            padding: 12px;
            border: 1px solid ${(props) => props.theme.votingCellBorder};
            border-radius: 4px;
            background-color: ${(props) => props.theme.background};
            color: ${(props) => props.theme.textPrimary};
            font-size: 14px;
            font-family: inherit;
            resize: vertical;
            outline: none;

            &:focus {
                border-color: ${(props) => props.theme.primary};
            }
        }

        .form-actions {
            display: flex;
            gap: 10px;
            margin-top: 10px;
            justify-content: flex-end;
        }
    }

    .comment {
        padding: 20px;
        border-bottom: 1px solid ${(props) => props.theme.votingCellBorder};

        &:last-child {
            border-bottom: none;
        }

        .comment-header {
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            margin-bottom: 10px;

            .comment-meta {
                display: flex;
                flex-direction: column;
                gap: 4px;

                .comment-date {
                    font-size: 12px;
                    color: ${(props) => props.theme.textSecondary};
                }
            }

            .comment-actions {
                display: flex;
                gap: 8px;
            }
        }

        .comment-body {
            color: ${(props) => props.theme.textPrimary};
            font-size: 14px;
            line-height: 1.5;
            white-space: pre-wrap;
            word-break: break-word;
        }
    }
`;


